import { UserT } from './Users';
import { WorkerT, } from './Worker';
import { VariablesObj, WorkerTypeTStrings } from './Company'

export interface InfractionT {
    comments: string
    date: string
    infraction: number // Corresponds to fk of rules set in Settings
    tier: number       // Allows 1, 2, and 3; 3 is the most several infraction
}
export interface DamageT {
    id: number // If id==-1, then return as `no damage` from db; if input is not-empty, it will return a non "-1" value
    amount: number
    cause: string  // Accident | Breach
    damageDate: string
    damageType: string     // TODO - Enumerate damage types
    itemDamaged: string    // TODO - Enumerate possible items
}




export const DamageObj : DamageT = {
    id: -1,
    amount: 0,
    cause: '',
    damageDate: '',
    damageType: '',
    itemDamaged: ''
}

export interface InvoiceWorkerT {
    id: string
    date: string
    item: WorkerTypeTStrings | null   // Options: laborVariable, laborFlat,
    rate: number
    units: number
    total: number
    paid?: boolean
    isDirty: boolean
    isAutoFill?: boolean
}

export interface JobWorkerT extends WorkerT {
    damages: Array<DamageT>
    infractions: Array<InfractionT>
    invoice: Array<InvoiceWorkerT>
    permissions?: Array<string>
    status: string // Can be: approved | denied | kicked | pending
    notes: string
    noShow: Boolean
    isDirty?: boolean
}

export const InfractionObj: InfractionT = {
    comments: '',
    date: '',
    infraction: null,
    tier: null
}


export const InvoiceWorkerObj: InvoiceWorkerT = {
    id: null,
    isDirty: false,
    date: '',
    item: null,
    rate: 12,
    units: VariablesObj.minimumTime.value,
    total: 50,
    paid: false,
    isAutoFill: true,
}

export const JobWorkerObj: JobWorkerT = {
    id: null,
    address: '',
    address2: '',
    addressDetails: {
        "address": "",
        "latitude": "",
        "longitude": "",
        "country": "",
        "state": "",
        "city": "",
        "address_line_one": "",
        "address_line_two": "",
        "zipcode": "",
    },
    billingContact: true,
    damages: [DamageObj],
    email: '',
    firstName: '',
    infractions: [InfractionObj],
    invoice: [InvoiceWorkerObj],
    lastName: '',
    phone: '',
    profilePic: '',
    rating: 2.5,     // Out of 5.0
    status: '',
    hourlyRate: 12,
    isCompany: false,
    jobs: [],
    notes: '',
    permissions: [],
    noShow: false,
}
